var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.952,
    height: 18,
    viewBox: "0 0 17.952 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_alt2",
    "data-name": "close alt2",
    d: "M31.228,15.83l-6.762,6.762L18.4,15.83a1.091,1.091,0,0,0-1.767-.038,1.1,1.1,0,0,0,0,1.729l6.07,6.762L15.86,31.2a1.1,1.1,0,0,0,0,1.729,1.017,1.017,0,0,0,1.69-.038l6.762-6.762,6.07,6.762A1.223,1.223,0,1,0,32.15,31.2l-6.07-6.762,6.839-6.916a1.054,1.054,0,0,0,.038-1.729A1.054,1.054,0,0,0,31.228,15.83Z",
    transform: "translate(-15.438 -15.359)",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3a1ba8d387b01e22b998fa676812b546.svg";
export { ForwardRef as ReactComponent };